import { useNavigate } from "react-router-dom";
import CityDropDown from "./CityDropDown";
import { useState } from "react";
import AnimatedSearchBar from "./AnimatedSearchBar";

export default function HeroCtaForm() {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  return (
    <div className="HeroCtaForm hero hero-text">
      <h2 className=" title" >
        Find your groove with Azzir – local events and artists just a tap away!
      </h2>
      <div className="location-sec">
        <form
          onSubmit={(event) => {
            event.preventDefault();
            navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
          }}
        >
          <CityDropDown />
          <AnimatedSearchBar
            onChange={(event) => {
              setSearchTerm(event.target.value);
            }}
          />
        </form>
      </div>
    </div>
  )
}
